function handleProductTextsPanels() {
  var list = document.querySelector('.product-texts-list');
  if (!list) return;

  function closeAll() {
    list.classList.remove('has-open');
    list.style.removeProperty('--product-panel-open-height');
    list.querySelectorAll('.product-texts-item.open').forEach(function(item) {
      item.classList.remove('open');
      var panel = item.querySelector('.product-text-panel');
      if (panel) panel.setAttribute('aria-expanded', 'false');
    });
  }

  function openItem(item) {
    closeAll();
    list.classList.add('has-open');
    item.classList.add('open');
    var panel = item.querySelector('.product-text-panel');
    if (panel) {
      panel.setAttribute('aria-expanded', 'true');
      if (window.innerWidth >= 821) {
        requestAnimationFrame(function() {
          var height = panel.offsetHeight;
          var gap = 4;
          list.style.setProperty('--product-panel-open-height', (height + gap) + 'px');
        });
      }
    }
  }

  list.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-texts-button');
    if (btn) {
      var item = btn.closest('.product-texts-item');
      if (!item) return;
      e.preventDefault();
      if (item.classList.contains('open')) {
        closeAll();
      } else {
        openItem(item);
      }
      return;
    }

  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && list.classList.contains('has-open')) closeAll();
  });
}

function handleProductImageLightbox() {
  var container = document.querySelector('#product-media-container');
  var lightbox = document.getElementById('product-image-lightbox');
  var content = lightbox && lightbox.querySelector('.product-lightbox-content');
  var slider = lightbox && lightbox.querySelector('.product-lightbox-slider');
  var lightboxSlides = lightbox && lightbox.querySelectorAll('.product-lightbox-slide');
  var lightboxImgs = lightbox && lightbox.querySelectorAll('.product-lightbox-img');
  if (!container || !lightbox || !content || !slider || !lightboxImgs.length) return;

  var closeBtn = lightbox.querySelector('.product-lightbox-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      lightbox.close();
      // Reset zoom icons from - back to +
      document.querySelectorAll('.product-media-item .zoom-icon').forEach(function(icon) {
        icon.innerHTML = '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
      });
    });
  }
  lightbox.addEventListener('click', function(e) {
    // Close only if clicking on the backdrop or the image (not on buttons or content wrapper)
    if (e.target === lightbox || e.target.closest('.product-lightbox-img')) {
      lightbox.close();
      // Reset zoom icons from - back to +
      document.querySelectorAll('.product-media-item .zoom-icon').forEach(function(icon) {
        icon.innerHTML = '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
      });
    }
  });
  lightbox.addEventListener('cancel', function() {
    lightbox.close();
    // Reset zoom icons from - back to +
    document.querySelectorAll('.product-media-item .zoom-icon').forEach(function(icon) {
      icon.innerHTML = '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
    });
  });

  // Reusable open logic (used by desktop click and mobile Swiper tap)
  function openLightbox(idx, sourceImg) {
    for (var i = 0; i < lightboxImgs.length; i++) {
      if (i === idx) {
        lightboxImgs[i].src = sourceImg.currentSrc || sourceImg.src;
        lightboxImgs[i].alt = sourceImg.alt || '';
      } else {
        lightboxImgs[i].src = lightboxImgs[i].dataset.src || lightboxImgs[i].getAttribute('data-src') || '';
      }
    }

    lightbox.showModal();
    requestAnimationFrame(function() {
      var slide = lightboxSlides[idx];
      if (slide && content) {
        var slideTop = slide.getBoundingClientRect().top;
        var contentTop = content.getBoundingClientRect().top;
        content.scrollTop += (slideTop - contentTop);
      }
    });
  }
  // Expose so the mobile Swiper "tap" handler can reuse it
  window.openProductLightbox = openLightbox;

  container.addEventListener('click', function(e) {
    var item = e.target.closest('.product-media-item');
    if (!item) return;
    var img = item.querySelector('img');
    if (!img) return;
    var idx = item.getAttribute('data-image-index');
    if (idx == null) return;
    idx = parseInt(idx, 10);

    // Desktop only: on mobile the Swiper "tap" event handles opening
    if (window.innerWidth < 820) return;

    // Change zoom icon from + to -
    var zoomIcon = item.querySelector('.zoom-icon');
    if (zoomIcon) {
      zoomIcon.innerHTML = '<line x1="5" y1="12" x2="19" y2="12"/>';
    }

    openLightbox(idx, img);
    e.preventDefault();
  });
}

document.addEventListener('DOMContentLoaded', function() {

  handleProductTextsPanels();

  handleProductImageLightbox();

  // Initialize/destroy Swiper for product media container based on screen size
  var productMediaSwiper = null;

  function setupNativePageZoom(mediaContainer, swiper) {
    function updateSwiperTouch() {
      if (!swiper || swiper.destroyed) return;
      var isPinching = mediaContainer._pinchActive === true;
      swiper.allowTouchMove = !isPinching;
    }

    mediaContainer._pinchActive = false;
    mediaContainer._pinchStartHandler = function(e) {
      mediaContainer._pinchActive = e.touches.length > 1;
      updateSwiperTouch();
    };
    mediaContainer._pinchEndHandler = function() {
      mediaContainer._pinchActive = false;
      updateSwiperTouch();
    };

    mediaContainer.addEventListener('touchstart', mediaContainer._pinchStartHandler, { passive: true });
    mediaContainer.addEventListener('touchend', mediaContainer._pinchEndHandler, { passive: true });
    mediaContainer.addEventListener('touchcancel', mediaContainer._pinchEndHandler, { passive: true });
  }

  function teardownNativePageZoom(mediaContainer) {
    if (!mediaContainer || !mediaContainer._pinchStartHandler) return;

    mediaContainer.removeEventListener('touchstart', mediaContainer._pinchStartHandler);
    mediaContainer.removeEventListener('touchend', mediaContainer._pinchEndHandler);
    mediaContainer.removeEventListener('touchcancel', mediaContainer._pinchEndHandler);

    mediaContainer._pinchActive = false;
    mediaContainer._pinchStartHandler = null;
    mediaContainer._pinchEndHandler = null;
  }
  
  function handleProductMediaSwiper() {
    var mediaContainer = document.querySelector('#product-media-container');
    if (!mediaContainer) return;

    var filterByColor = mediaContainer.getAttribute('data-filter-slides-by-color') === 'true';

    if (window.innerWidth < 820) {
      // Initialize swiper on mobile. Use loop: false when filtering by color so hidden slides can be removed from DOM.
      if (!productMediaSwiper) {
        productMediaSwiper = new Swiper(mediaContainer, {
          loop: !filterByColor,
          speed: 400,
          spaceBetween: 10,
          grabCursor: true,
          touchStartPreventDefault: false,
          passiveListeners: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          pagination: {
            el: mediaContainer.querySelector('.swiper-pagination'),
            clickable: true
          },
          on: {
            tap: function(swiper, event) {
              if (window.visualViewport && window.visualViewport.scale > 1.01) return;
              var item = event.target.closest('.product-media-item');
              if (!item) return;
              var img = item.querySelector('img');
              if (!img) return;
              var idx = item.getAttribute('data-image-index');
              if (idx == null) return;
              if (window.openProductLightbox) {
                window.openProductLightbox(parseInt(idx, 10), img);
              }
            }
          }
        });
        setupNativePageZoom(mediaContainer, productMediaSwiper);
        window.productMediaSwiper = productMediaSwiper;
      }
    } else {
      // Destroy swiper on desktop
      if (productMediaSwiper) {
        teardownNativePageZoom(mediaContainer);
        productMediaSwiper.destroy(true, true);
        productMediaSwiper = null;
        window.productMediaSwiper = null;
      }
    }
  }

  handleProductMediaSwiper();

  // Recalculate swiper on window resize
  window.addEventListener('resize', function() {
    handleProductMediaSwiper();
    handleCursorProduct();
  });

  // Follow cursor with zoom icon (desktop only)
  function handleCursorProduct() {
    document.querySelectorAll('.product-media-item').forEach(function(item) {
      var cursorElement = item.querySelector('.cursor-product');
      if (!cursorElement) return;

      if (window.innerWidth < 820) {
        // Mobile: remove listeners
        if (item._cursorListenersAdded) {
          item.removeEventListener('mousemove', item._mousemoveHandler);
          item.removeEventListener('mouseleave', item._mouseleaveHandler);
          item._cursorListenersAdded = false;
        }
      } else {
        // Desktop: add listeners if not already added
        if (!item._cursorListenersAdded) {
          item._mousemoveHandler = function(e) {
            var rect = this.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var y = e.clientY - rect.top;
            
            cursorElement.style.position = 'absolute';
            cursorElement.style.left = x + 'px';
            cursorElement.style.top = y + 'px';
            cursorElement.style.transform = 'translate(-50%, -50%)';
            cursorElement.style.pointerEvents = 'none';
          };

          item._mouseleaveHandler = function() {
            cursorElement.style.position = 'absolute';
            cursorElement.style.left = '50%';
            cursorElement.style.top = '50%';
            cursorElement.style.transform = 'translate(-50%, -50%)';
          };

          item.addEventListener('mousemove', item._mousemoveHandler);
          item.addEventListener('mouseleave', item._mouseleaveHandler);
          item._cursorListenersAdded = true;
        }
      }
    });
  }

  handleCursorProduct();

  // Follow cursor with lightbox zoom icon
  var lightboxSlides = document.querySelectorAll('.product-lightbox-slide');
  
  lightboxSlides.forEach(function(slide) {
    var cursorLightbox = slide.querySelector('.cursor-lightbox');
    if (!cursorLightbox) return;

    slide.addEventListener('mousemove', function(e) {
      if (window.innerWidth < 820) return;
      var rect = this.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      
      cursorLightbox.style.position = 'absolute';
      cursorLightbox.style.left = x + 'px';
      cursorLightbox.style.top = y + 'px';
      cursorLightbox.style.transform = 'translate(-50%, -50%)';
      cursorLightbox.style.pointerEvents = 'none';
      cursorLightbox.style.opacity = '1';
    });

    slide.addEventListener('mouseleave', function() {
      cursorLightbox.style.opacity = '0';
    });
  });
});